import {
  Checkbox,
  checkboxStates,
  Modal,
  NewButton,
  NewButtonVariant,
} from "@visiblethread/react-components";
import clsx from "clsx";
import { noop } from "lodash";
import { bool, func, node, number, string } from "prop-types";
import { useDispatch } from "react-redux";
import { hideModal } from "slices/app/actions/modals";

import classes from "./HeadingSyncModal.module.scss";

const MAX_INDENT_DEPTH = 6;

export const SectionNameCell = ({
  title,
  annotation,
  strikethrough = false,
  reserveAnnotationWidth = false,
  depth = 0,
}) => {
  const safeDepth = Math.max(
    0,
    Math.min(MAX_INDENT_DEPTH, Number.isFinite(depth) ? depth : 0)
  );
  const indentClass =
    safeDepth > 0
      ? classes[`heading_sync_modal__title--depth-${safeDepth}`]
      : null;
  return (
    <span className={classes["heading_sync_modal__section_cell"]}>
      <span
        className={clsx(classes["heading_sync_modal__title"], indentClass, {
          [classes["heading_sync_modal__strikethrough"]]: strikethrough,
        })}
      >
        {title}
      </span>
      <span
        className={clsx(classes["heading_sync_modal__annotation"], {
          [classes["heading_sync_modal__annotation--reserved"]]:
            reserveAnnotationWidth,
        })}
      >
        {annotation}
      </span>
    </span>
  );
};

SectionNameCell.propTypes = {
  title: string,
  annotation: string,
  strikethrough: bool,
  reserveAnnotationWidth: bool,
  depth: number,
};

export const KeepCheckbox = ({ title, isKept, onToggle, disabled = false }) => (
  <Checkbox
    aria-label={`Keep ${title}`}
    state={isKept ? checkboxStates.checked : checkboxStates.empty}
    handleChange={onToggle}
    disabled={disabled}
  />
);

KeepCheckbox.propTypes = {
  title: string,
  isKept: bool,
  onToggle: func,
  disabled: bool,
};

export const HeadingSyncModalShell = ({
  modalType,
  headerText,
  submitText,
  onClose = noop,
  onSubmit,
  children,
}) => {
  const dispatch = useDispatch();
  const onCancel = () => {
    dispatch(hideModal(modalType));
    onClose();
  };

  return (
    <Modal
      data-testid="heading-sync-modal"
      className={clsx("fade-in", classes["heading_sync_modal"])}
      show
      onDismiss={onCancel}
      backdrop
      centered
    >
      <Modal.Header>{headerText}</Modal.Header>

      <Modal.Body className={classes["heading_sync_modal__body"]}>
        {children}
      </Modal.Body>

      <Modal.Footer>
        <NewButton
          data-testid="cancel-heading-sync"
          variant={NewButtonVariant.l2}
          onClick={onCancel}
        >
          Cancel
        </NewButton>

        <NewButton
          data-testid="sync-and-save"
          variant={NewButtonVariant.l1}
          onClick={onSubmit}
        >
          {submitText}
        </NewButton>
      </Modal.Footer>
    </Modal>
  );
};

HeadingSyncModalShell.propTypes = {
  modalType: string,
  headerText: string,
  submitText: string,
  onClose: func,
  onSubmit: func,
  children: node,
};
